import { useShellAuth0, type ShellAuth0ContextInterface } from "@opengov/shell-auth0-react";
import type { GetTokenSilentlyOptions } from "@auth0/auth0-react";

export const useSafeAuth0GetAccessToken: () => Pick<ShellAuth0ContextInterface, "getAccessTokenSilently"> = () => {
  const { getAccessTokenSilently } = useShellAuth0();
  // Return a safe wrapper around getAccessTokenSilently
  const safeGetAccessTokenSilently = async (options?: GetTokenSilentlyOptions) => {
    try {
      return await getAccessTokenSilently(options);
    } catch (error) {
      return options?.detailedResponse ? {} : "";
    }
  };
  return { getAccessTokenSilently: safeGetAccessTokenSilently as ShellAuth0ContextInterface["getAccessTokenSilently"] };
};
